import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const DigitalHeroSlide = ({
  title = "Digital First",
  subtitle = "Transform your business with modern digital solutions that prioritize user experience and innovation",
  textColor = "text-blue-100",
  primaryLink = {
    text: "Get Started",
    to: "/contact",
    className: "bg-white text-blue-600 hover:bg-gray-100",
  },
  secondaryLink = {
    text: "Learn More",
    to: "/services",
    className: "border border-white text-white hover:bg-white hover:text-blue-600",
  },
}) => {
  const scrollIntoView = () => {
    const element = document.getElementById("learn-more-digital");
    if (element) {
      const yOffset = -80; // adjust based on your header height
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  return (
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-28 lg:py-56 z-40">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="text-center"
      >
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
          {title}
        </h1>
        <p className={`text-xl md:text-2xl mb-8 font-medium ${textColor}`}>
          {subtitle}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to={primaryLink.to}
            className={`px-8 py-3 rounded-md transition-colors font-medium ${primaryLink.className}`}
          >
            {primaryLink.text}
          </Link>
          <Link
            to='#'
            onClick={scrollIntoView}
            className={`px-8 py-3 rounded-md transition-colors font-medium ${secondaryLink.className}`}
          >
            {secondaryLink.text}
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default DigitalHeroSlide;
